import { combineReducers } from 'redux';

import contextReducer from './context.reducer';
import formReducers from './form.reducers';

export default combineReducers({
  context: contextReducer,
  form: formReducers,
});
